<template>
<van-popup v-model="show" position="bottom" @click-overlay="handleClosePupup" >
    <div class="container">
      <ul class="sharing-zone">
        <li
          v-for="(action) of actions"
          :key="action.key"
          @click="action.callback"
        >
          <svg-icon v-if="action.key !== 'sharing-meixin'" :icon="sharingIconMapping[action.key]" cls="sharing-zone-icon" />
          <img v-else src='@/assets/meixin.png' alt="">
          <div>{{action.name}}</div>
        </li>
      </ul>
      <van-button type="default" size="large" @click="handleClosePupup">{{$t('base.cancel')}}</van-button>
    </div>
</van-popup>
</template>
<script>
import SvgIcon from '../utils/SvgIcon'

export default {
  name: 'sharingPopup',
  components: {
    SvgIcon
  },
  data () {
    const { shareAction } = this.$route.query

    return {
      show: shareAction,
      sharingIconList: ['Share_Colleaguex', 'Share_EnterpriseWec', 'Share_Wechatx', 'Share_copyx'],
      sharingIconMapping: {
        'send-to-colleague': 'Share_Colleaguex',
        'enterpriseWechat': 'Share_EnterpriseWec',
        'Wechat': 'Share_Wechatx',
        'sharing-link': 'Share_copyx',
        'sharing-meixin': 'Share_copyx'
      }
    }
  },
  props: {
    actions: Array,
    actionItem: null,
    actionFrom: String,
    actionName: String,
    actionTitle: String
  },
  methods: {
    handleClosePupup () {
      this.$emit('close-handler')
      this.$router.go(-1)
    }
  },
  watch: {
    $route (to) {
      const { shareAction } = to.query

      if (shareAction) {
        this.show = true
      } else {
        this.show = false
      }
    }
  }
}
</script>
<style lang="postcss" scoped>
@import 'variables';

.container {
  width: 100%;

  & .sharing-zone {
    margin: 10px;
    display: flex;
    flex-wrap: wrap;

    & li {
      width: 25%;
      text-align: center;

      & .sharing-zone-icon {
        width: 46px;
        height: 46px;
        margin: 15px 0;
      }

      & div {
        font-size: 13px;
        color: #8894a1;
      }
      & img{
        width: 46px;
        height: 46px;
        margin: 15px 0;
      }
    }
  }
}
</style>
